export const parseConfirmationNavigation = (search, origin = window.location.origin) => {
  const params = new URLSearchParams(search || '')
  const token = params.get('token') || null
  const requestedNext = params.get('next')
  if (!requestedNext) {
    return {token, nextPath: null}
  }

  try {
    const destination = new URL(requestedNext, origin)
    if (destination.origin !== origin || !destination.pathname.startsWith('/')) {
      return {token, nextPath: null}
    }
    return {
      token,
      nextPath: `${destination.pathname}${destination.search}${destination.hash}`,
    }
  } catch (_error) {
    return {token, nextPath: null}
  }
}

export const buildLoginDestination = (nextPath) =>
  nextPath ? `/auth/login?next=${encodeURIComponent(nextPath)}` : '/auth/login'
